module.exports = __webpack_public_path__ + "img/pm25.ff714117.png";